import React from 'react';
import KickImage from 'Reuseables/KickImage';
import MonthButton from '../../Molecules/MonthButton';
import PostItem from '../../Molecules/PostItem';

import { IPostsProps } from './Posts.definitions';

/** CSS import */
import Styles from './Posts.module.scss';

import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import { TextBlock, RectShape } from 'react-placeholder/lib/placeholders';
import { useCalendarMonthGetter } from 'Pages/Blog/Hooks/useCalendarMonthGetter';
import useFetchCalendarData from 'Pages/Blog/Hooks/useFetchCalendarData';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import Empty from '../../Molecules/Empty';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';

const Posts: React.FC<IPostsProps> = ({ bodyScrollableRef }: IPostsProps) => {
  const [selectedMonth, setSelectedMonth] = React.useState<number>(
    new Date().getMonth() + 1,
  );
  const [selectedYear, setSelectedYear] = React.useState<number>(
    new Date().getFullYear(),
  );

  const { month } = useCalendarMonthGetter();
  const { fetchCalendarData, data, isFetching, hasMore, page } =
    useFetchCalendarData();

  React.useEffect(() => {
    fetchCalendarData(selectedMonth, selectedYear, true);
  }, [selectedMonth, selectedYear]);

  const Placeholder = React.useMemo(
    () => (
      <div className={Styles['placeholder']}>
        {Array.from({ length: 4 }).map((_, index) => (
          <div className={Styles['placeholder-item']}>
            <RectShape color="#eeeeee" className={Styles['image']} />
            <TextBlock rows={3} color="#eeeeee" />
          </div>
        ))}
      </div>
    ),
    [],
  );

  const nextPage = () => {
    fetchCalendarData(selectedMonth, selectedYear);
  };

  const refresh = () => {
    fetchCalendarData(selectedMonth, selectedYear, true);
  };

  const isReady = React.useMemo(() => {
    if (page === 1) {
      return !isFetching;
    }
    return true;
  }, [isFetching, page, selectedMonth, selectedYear]);

  const { isMobileView } = useGetViewType();

  return (
    <div className={Styles['wrapper']}>
      <p className={Styles['title']}>Calendar</p>
      <div className={Styles['month-container']}>
        {month.map((month) => (
          <MonthButton
            text={month.text}
            onClick={() => {
              setSelectedMonth(month.id);
              setSelectedYear(month.year);
            }}
            isActive={month.id === selectedMonth}
          />
        ))}
      </div>
      <ReactPlaceholder ready={isReady} customPlaceholder={Placeholder}>
        <InfiniteScroll
          dataLength={data.length} //This is important field to render the next data
          next={nextPage}
          hasMore={hasMore}
          loader={Placeholder}
          endMessage={null}
          // below props only if you need pull down functionality
          refreshFunction={refresh}
          pullDownToRefresh={isMobileView}
          pullDownToRefreshThreshold={50}
          pullDownToRefreshContent={
            <h3 style={{ textAlign: 'center' }}>
              &#8595; Pull down to refresh
            </h3>
          }
          releaseToRefreshContent={
            <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
          }
          scrollableTarget={bodyScrollableRef?.current}
          scrollThreshold={0.9}
        >
          <div className={Styles['post-container']}>
            {data.length === 0 && <Empty />}
            {data.map((post) => (
              <PostItem
                key={post.id}
                title={post.title}
                date={moment(post.created_at).format('MMMM DD, YYYY')}
                image={
                  post.thumbnail?.URL ?? 'https://picsum.photos/200'
                }
                url={`/kickavenews/${post.slug}`}
              />
            ))}
          </div>
        </InfiniteScroll>
      </ReactPlaceholder>
    </div>
  );
};

export default Posts;
